import { useState, useEffect } from 'react';
import { supabase } from '../../lib/supabase';

/**
 * Hook to fetch and manage players associated with the current parent
 */
export function useParentPlayers(isParentMode: boolean) {
  const [parentPlayers, setParentPlayers] = useState<any[]>([]);
  const [selectedParentPlayerId, setSelectedParentPlayerId] = useState('');
  const [selectedPlayer, setSelectedPlayer] = useState<any>(null);
  const [error, setError] = useState<string | null>(null);
  
  // Fetch parent's players
  async function loadParentPlayers() {
    // Anonymous user won't load anything
    if (!supabase.auth) return;
    
    const {
      data: { user },
    } = await supabase.auth.getUser();
    
    if (!user) return;
    
    // Fetch parent's players using the player_parent_relationships table
    const { data, error } = await supabase
      .from('player_parent_relationships')
      .select('player:player_id(*)')
      .eq('parent_id', user.id);
      
    if (error) {
      console.error('Failed to fetch players for parent:', error);
      setError(error.message);
    } else if (data) {
      // Extract player data from the relationships
      const playersData = data.map((rel) => rel.player);
      setParentPlayers(playersData);
    }
  }
  
  // Handle player selection
  function handleSelectParentPlayer(playerId: string) {
    setSelectedParentPlayerId(playerId);
    setError(null);
    
    // Find the selected player from the parent players list
    const player = parentPlayers.find(p => p.id === playerId);
    setSelectedPlayer(player);
  }
  
  // Load parent players when in parent mode
  useEffect(() => {
    if (isParentMode) {
      loadParentPlayers();
    }
  }, [isParentMode]);
  
  return {
    parentPlayers,
    selectedParentPlayerId,
    selectedPlayer,
    error,
    handleSelectParentPlayer,
    resetParentPlayerSelection: () => {
      setSelectedParentPlayerId('');
      setSelectedPlayer(null);
    }
  };
}
